// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__Kd2it","spin":"styles_spin__MGl+O"};